module.exports = __webpack_public_path__ + "static/media/measurement-left.f68ee735.svg";